import { useMemo } from "react";
import { useTheme } from "@fluentui/react/lib/Theme";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";

import { textOverflow } from "Utils/Styles";

const classNames = {
  root: `ResultCard`,
  titleWrap: `ResultCardTitleWrap`,
  title: `ResultCardTitle`,
  badge: `ResultCardBadge`
};

export function useResultCardStyles() {
  const { effects, semanticColors } = useTheme();
  return useMemo(
    () => mergeStyleSets({
      root: [
        classNames.root,
        {
          paddingLeft: `48px`,
          marginBottom: `25px`
        }
      ],
      titleWrap: [
        classNames.titleWrap,
        {
          minHeight: `26px`,
          marginBottom: `15px`
        }
      ],
      title: [
        classNames.title,
        {
          ...textOverflow
        }
      ],
      badge: [
        classNames.badge,
        {
          backgroundColor: semanticColors.bodyStandoutBackground,
          boxShadow: effects.elevation4,
          padding: `5px 10px`,
          borderRadius: `20px`,
          minWidth: `11px`,
          textAlign: `center`,
          "& *": {
            color: semanticColors.disabledText,
            fontWeight: `600`
          }
        }
      ]
    }),
    [effects, semanticColors]
  );
}
